<template>
  <div>
    <generic-modal
      v-if="showThankYouModal"
      @close="closeThankYouModal($event, '')"
      :height="thankYouModalDim.height"
      :width="thankYouModalDim.width"
      :modalClass="thankYouModalDim.modalClass"
      :contentScroll="false"
    >
      <template v-slot:header> </template>
      <template v-slot:body>
        <div class="lottie-confetti">
          <VueLottiePlayer
            name="confettiAnim"
            width="100%"
            height="100%"
            loop
            :animationData="require('../assets/ConfettiOrderSuccessful.json')"
          />
        </div>
        <div class="thank-you-body">
          <div class="thank-you-tick-container">
            <i class="hkfi-thank-you-tick"></i>
          </div>
          <div class="thank-you-text bold fs-16">
            Your Order has been placed
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <div></div>
      </template>
    </generic-modal>
    <div class="thank-you-loader" v-else>
      <VueLottiePlayer
        name="confettiAnim"
        width="25%"
        height="25%"
        loop
        :animationData="require('../assets/hongs-order-tracker.json')"
        v-if="clientPlatform !== 'Web'"
      />
      <VueLottiePlayer
        name="confettiAnim"
        width="20%"
        height="20%"
        loop
        :animationData="require('../assets/hongs-order-tracker.json')"
        v-else
      />
      <div class="center-alligned-text pt16">
        <div class="bold fs-16">Relax!</div>
        <div class="fs-14 width80 tc">
          Unwind while we handle your order confirmation!
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
import GenericModal from "./GenericModal.vue";
import { clientPlatform } from "../config/apiEndpoints";
import Utility from "../helpers/utility";
import {
  keyMapsGetter,
  keyMapsAction,
  keyMapsMutation,
} from "../helpers/storeKeys";
import LocalStorageFunc from "../helpers/localStorageFunc";

export default {
  name: "ThankYou",
  components: {
    VueLottiePlayer: defineAsyncComponent(() => import("vue-lottie-player")),
    GenericModal,
  },
  data() {
    return {
      thankYouModalDim: {
        width: "100vw",
        height: "100vh",
        modalClass: "full-screen-popup thank-you-wrap",
      },
      clientPlatform,
    };
  },
  mounted() {
    let queryParams = Utility.getQueryFromUrl();
    if (queryParams["transactionId"]) {
      setTimeout(() => {
        this.$store.dispatch(keyMapsAction.POST_SUBMIT_TRACK_ORDER, {
          transactionId: queryParams["transactionId"],
        });
      }, 2000);
    }
    LocalStorageFunc.emptyCart();
  },
  methods: {
    closeThankYouModal(e, type) {
      this.$store.commit(keyMapsMutation.UPDATE_SHOW_THANK_YOU_MODAL, false);
    },
  },
  computed: {
    showThankYouModal() {
      if (this.$store.state.ThankYou.showThankYou) {
        let queryParams = Utility.getQueryFromUrl();
        if (queryParams["transactionId"]) {
          setTimeout(() => {
            Utility.sendToOrderTracking(queryParams["transactionId"]);
          }, 2000);
        }
      }
      return this.$store.getters[keyMapsGetter.GET_SHOW_THANK_YOU_MODAL];
      // return true;
    },
  },
};
</script>

<style></style>
